import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneNumberFormat',
  standalone: true,
})
export class PhoneNumberFormatPipe implements PipeTransform {

  transform(value: string | number | null | undefined): string {
    if (!value) {
      return '';
    }
    const digits = value.toString().replace(/\D/g, '');

    if (digits.length !== 11) {
      return value.toString();
    }

    const countryCode = digits[0];
    const areaCode = digits.slice(1, 4);
    const firstPart = digits.slice(4, 7);
    const secondPart = digits.slice(7, 9);
    const thirdPart = digits.slice(9);

    return `+${countryCode} (${areaCode}) ${firstPart}-${secondPart}-${thirdPart}`;
  }
}
